import { provideHttpClient, withXhr } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { API_CONFIG, ApiGatewayConfig } from '../types';

export function provideApiGateway(
  config: ApiGatewayConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(withXhr()),
    {
      provide: API_CONFIG,
      useValue: config,
    },
  ]);
}
